module.exports = __webpack_public_path__ + "ptc_momoro_V1.920aaa08.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/momoro/parent_to_child/ptc_momoro_V1.jpg
// module id = JPJX
// module chunks = 0